import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../../services/common.service';
import {ExcelService} from '../../../../services/excel.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-custom-form-reminders-dialog',
  templateUrl: './custom-form-reminders-dialog.component.html',
  styleUrls: ['./custom-form-reminders-dialog.component.scss']
})
export class CustomFormRemindersDialogComponent implements OnInit {
  title = '';
  records: MatTableDataSource<any> = new MatTableDataSource<any>();
  uniqueId = null;
  isLoading: boolean;
  mode: number;
  displayedColumns = ['action_date', 'to', 'actions'];
  constructor(public dialogRef: MatDialogRef<CustomFormRemindersDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public excelService: ExcelService,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) {
    this.title = data.title;
    this.uniqueId = data.uniqueId;
    this.isLoading = false;
    this.mode = +data.mode;
  }

  async ngOnInit() {
    try {
      const request: any = this.mode === 1 ?
          await this.commonService.getList(`reports/reminder-history?uniqueId=${this.uniqueId}`) :
          await this.commonService.getList(`reports/parent-reminder-history?uniqueId=${this.uniqueId}`);
      for (const record of request.object) {
        const to = JSON.parse(record.to);
        record.recipients = to.length;
      }
      this.records = new MatTableDataSource<any>(request.object);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e);
    }
  }

  close() {
    this.dialogRef.close();
  }

  exportToExcel(element) {
    const data = JSON.parse(element.to);
    const {records, columns} = this.formatModel(data);
    const fileName = `Ιστορικό υπενθύμισης ${this.title} - ${element.action_date}`;
    this.excelService.exportAsCustomExcelFile(records, fileName, columns);
  }

  formatModel(data) {
    const records = [];
    for (const record of data) {
      const model = {
        child_first_name: record.child_first_name,
        child_last_name: record.child_last_name,
        parent_first_name: record.parent_first_name,
        parent_last_name: record.parent_last_name,
        email: record.email,
        phone: record.phone
      };
      records.push(model);
    }

    const columns = [{
      key: 'parent_first_name',
      label: 'Όνομα',
    },
      {
        key: 'parent_last_name',
        label: 'Επώνυμο',
      },
      {
        key: 'email',
        label: 'Εmail',
      },
      {
        key: 'phone',
        label: ' Τηλέφωνο',
      }, {
        key: 'child_first_name',
        label: 'Όνομα παιδιού',
      }, {
        key: 'child_last_name',
        label: 'Επώνυμο παιδιού',
      },
    ];

    return {records, columns};
  }
}
